import { RootState } from '../Application';
import { isConfigReady } from '../domain/Config/Conditions';
import { hasActiveProduct } from '../domain/Order/Conditions';
import { app } from '../initApp';
import { Condition } from '../screen/Condition';
import { UseCase } from './usecase/UseCase';

export const showGraphicsTabUseCase:UseCase = {
  type: 'SHOW_GRAPHICS_TAB',

  checkConditions: ( state: RootState ) => {
    return Condition.evaluate(state, [isConfigReady, hasActiveProduct]);
  },

  run: () => {
    // @ts-ignore
    return Cx.resolve();
  }
};

export function canShowGraphicsTab(state: RootState) {
  return showGraphicsTabUseCase.checkConditions( state ).isAllowed;
}

export function showGraphicsTab(){
  app.runUseCase(showGraphicsTabUseCase);
}
